import { css } from "lit";

export const holloHeaderStyles = css`
  .hollo-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 11px 16px;
    background: #fff;
    border-bottom: 1px solid #eef2f7;
  }
  .hollo-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .hollo-header-avatar {
    flex-shrink: 0;
  }
  .hollo-user-meta {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .hollo-header-title {
    font-weight: 700;
    color: #111827;
    font-size: 16px;
  }
  .hollo-right {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
  }

  .hollo-flag-btn {
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 50%;
    display: grid;
    place-items: center;
    background: transparent;
    cursor: pointer;
    font-size: 18px;
    padding: 0;
    flex-shrink: 0;
  }
  .hollo-flag-img {
    width: 32px;
    height: 32px;
    object-fit: cover;
    border-radius: 50%;
  }
  .hollo-flag-emoji {
    line-height: 1;
  }
  .hollo-icon-btn {
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 12px;
    display: grid;
    place-items: center;
    cursor: pointer;
    background: #ecfdf5;
    color: #065f46;
  }

  .hollo-switch {
    position: relative;
    width: 44px;
    height: 24px;
  }
  .hollo-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .hollo-slider {
    position: absolute;
    inset: 0;
    border-radius: 999px;
    background: #e5e7eb;
    transition: background 0.2s;
    cursor: pointer;
  }
  .hollo-slider::before {
    content: "";
    position: absolute;
    width: 18px;
    height: 18px;
    top: 3px;
    left: 3px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    transition: transform 0.2s;
  }
  .hollo-switch input:checked + .hollo-slider {
    background: #fb7185;
  }
  .hollo-switch input:checked + .hollo-slider::before {
    transform: translateX(20px);
  }
  .hollo-user-name {
    color: #111827;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    font-family: "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.01em;
    text-transform: none;
  }
  .hollo-user-phone {
    color: #00adee;
    text-align: left;
    font-family: "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: -0.01em;
    text-transform: none;
    text-decoration: none;
    display: inline-block;
  }
  .hollo-live-toggle {
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 50%;
    display: grid;
    place-items: center;
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
    transition: background 0.2s ease;
  }
  .hollo-live-toggle:hover {
    background: #2563eb;
  }
  .hollo-live-toggle svg {
    width: 32px;
    height: 32px;
  }
  .live-on {
    background: #bbc6ca;
  }
  .live-off {
    background: #00adee;
  }
  .hollo-live-toggle-icon {
    display: flex;
    align-items: bottom;
    justify-content: center;
  }
  .hollo-menu-btn {
    width: 32px;
    height: 32px;
    display: grid;
    place-items: center;
    background: transparent;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    color: #6c7e85;
    padding: 0;
    flex-shrink: 0;
  }
  .hollo-menu-btn:hover {
    background: transparent;
  }
  .hollo-menu-btn svg {
    display: block;
  }
  .hollo-menu-btn svg path {
    transition: stroke 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .hollo-menu-btn:hover svg path {
    stroke: #6c7e85;
  }
  .gap-4 {
    gap: 4px;
  }
  .hollo-skel-name {
    display: inline-block;
    width: 140px;
    height: 16px;
    border-radius: 6px;
    background: linear-gradient(90deg, #f2f4f8 0%, #eaeef4 50%, #f2f4f8 100%);
    background-size: 200% 100%;
    animation: hollo-skel-shimmer 1.2s ease-in-out infinite;
  }
  @keyframes hollo-skel-shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;
